export default [
  {
    title: 'breadcrumb.betSetting',
    route: 'bet-setting',
    icon: '',
    resource: 'bet-setting',
    action: 'read',
  },
  {
    title: 'breadcrumb.bank',
    route: 'list-bank',
    icon: '',
    resource: 'bank-setting',
    action: 'read',
  },
  {
    title: 'breadcrumb.reward',
    route: 'list-reward',
    icon: '',
    resource: 'reward',
    action: 'read',
  },
  {
    title: 'breadcrumb.claimRewardHistory',
    route: 'list-claim-reward-history',
    icon: '',
    resource: 'claim-reward',
    action: 'read',
  },
  {
    title: 'breadcrumb.pointRule',
    route: 'point-rule',
    icon: '',
    resource: 'point-rule',
    action: 'read',
  },
  // {
  //   title: 'breadcrumb.matchVideo',
  //   route: 'list-match-video',
  //   icon: '',
  //   resource: 'video-live-upload',
  //   action: 'read',
  // },
]
